module.exports = __webpack_public_path__ + "static/media/arbeitsmittel_active_true_handschuhe_falsch.f869b101.jpg";